var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"report_card-header mb-4"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"bar-chart",attrs:{"id":`bar-chart-${this.subject}`}}),_c('div',{staticClass:"ml-5 my-3 d-flex",attrs:{"id":`bar-${this.subject}-legend`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }